import "@/App.css";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import SearchResults from "@/pages/SearchResults";
import RoutePage from "@/pages/RoutePage";
import PackageRoutePage from "@/pages/PackageRoutePage";
import SendPackage from "@/pages/SendPackage";
import DriverProfile from "@/pages/DriverProfile";
import CityPage from "@/pages/CityPage";
import RatingPage from "@/pages/RatingPage";
import ComplaintPage from "@/pages/ComplaintPage";
import BlogList from "@/pages/BlogList";
import ArticlePage from "@/pages/ArticlePage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import AboutPage from "@/pages/AboutPage";
import FAQPage from "@/pages/FAQPage";
import TrackOrder from "@/pages/TrackOrder";
import MyOrders from "@/pages/MyOrders";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import DriverDashboard from "@/pages/DriverDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";
import AllRoutes from "@/pages/AllRoutes";
import SitemapPage from "@/pages/SitemapPage";

function SlugPage() {
  const { slug } = useParams();
  if (slug.startsWith("paket-kilat-")) return <PackageRoutePage />;
  if (slug.startsWith("travel-dari-") || slug.startsWith("travel-ke-")) return <CityPage />;
  return <RoutePage />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cari" element={<SearchResults />} />
            <Route path="/masuk" element={<Login />} />
            <Route path="/daftar" element={<Register />} />
            <Route path="/dashboard-driver" element={<DriverDashboard />} />
            <Route path="/dashboard-admin" element={<AdminDashboard />} />
            <Route path="/ulasan" element={<RatingPage />} />
            <Route path="/ulasan/:orderNumber" element={<RatingPage />} />
            <Route path="/pengaduan" element={<ComplaintPage />} />
            <Route path="/pengaduan/:orderNumber" element={<ComplaintPage />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<ArticlePage />} />
            <Route path="/syarat-ketentuan" element={<TermsPage />} />
            <Route path="/kebijakan-privasi" element={<PrivacyPage />} />
            <Route path="/tentang-kami" element={<AboutPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/lacak-order" element={<TrackOrder />} />
            <Route path="/lacak-order/:orderNumber" element={<TrackOrder />} />
            <Route path="/pesan-travel" element={<SearchResults forcedService="door_to_door" />} />
            <Route path="/pesan-charter" element={<SearchResults forcedService="charter" />} />
            <Route path="/pesan-paket" element={<SendPackage />} />
            <Route path="/pesanan-saya" element={<MyOrders />} />
            <Route path="/kirim-paket" element={<SendPackage />} />
            <Route path="/rute" element={<AllRoutes />} />
            <Route path="/sitemap" element={<SitemapPage />} />
            <Route path="/driver/:driverId" element={<DriverProfile />} />
            <Route path="/:slug" element={<SlugPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
